<template>
  <!-- <div style="height: 90%;"> -->
    <!-- <div class="header">
      <h1>粉丝数据统计分析</h1>
      <p>展示粉丝总数、活跃粉丝数和不活跃粉丝数的对比</p>
    </div> -->
    
    <div class="chart-container">
      <div class="chart-wrapper">
        <div ref="chart" style="width: 100%; height: 100%;"></div>
      </div>
    </div>
    
    <!-- <div class="data-info">
      <div class="data-item" v-for="(item, index) in xData" :key="index">
        <div class="color-indicator" :style="{background: getColor(index)}"></div>
        {{ item }}: {{ yData[index] }}
      </div>
    </div> -->
  <!-- </div> -->
</template>

<script>
// 注意：在Vue项目中需要先安装echarts: npm install echarts
import * as echarts from 'echarts'

export default {
  name: 'FansChart',
  data() {
    return {
      xData: ["设备总数", "在线数量", "离线数量"],
      yData: [1096, 903, 63],
      myChart: null
    }
  },
  computed: {
    chartOption() {
      return {
        backgroundColor: '#061326',
        grid: {
          top: '25%',
          left: '-5%',
          bottom: '5%',
          right: '5%',
          containLabel: true
        },
        tooltip: {
          show: true 
        },
        animation: false,
        xAxis: [{
          type: 'category',
          data: this.xData,
          axisTick: {
            alignWithLabel: true
          },
          nameTextStyle: {
            color: '#82b0ec'
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#82b0ec'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            },
            margin: 30
          }
        }],
        yAxis: [{
          show: false,
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#0c2c5a'
            }
          },
          axisLine: {
            show: false
          }
        }],
        series: [
          {
            name: '',
            type: 'pictorialBar',
            symbolSize: [40, 10],
            symbolOffset: [0, -6],
            symbolPosition: 'end',
            z: 12,
            label: {
              normal: {
                show: true,
                position: 'top',
                fontSize: 25,
                fontWeight: 'bold',
                color: '#34DCFF'
              }
            },
            color: '#2DB1EF',
            data: this.yData
          },
          {
            name: '',
            type: 'pictorialBar',
            symbolSize: [40, 10],
            symbolOffset: [0, 7],
            z: 12,
            color: '#2DB1EF',
            data: this.yData
          },
          {
            name: '',
            type: 'pictorialBar',
            symbolSize: [50, 15],
            symbolOffset: [0, 12],
            z: 10,
            itemStyle: {
              normal: {
                color: 'transparent',
                borderColor: '#2EA9E5',
                borderType: 'solid',
                borderWidth: 1
              }
            },
            data: this.yData
          },
          {
            name: '',
            type: 'pictorialBar',
            symbolSize: [70, 20],
            symbolOffset: [0, 18],
            z: 10,
            itemStyle: {
              normal: {
                color: 'transparent',
                borderColor: '#19465D',
                borderType: 'solid',
                borderWidth: 2
              }
            },
            data: this.yData
          },
          {
            type: 'bar',
            barWidth: '40',
            barGap: '10%',
            barCategoryGap: '10%',
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.7, [
                  {
                    offset: 0,
                    color: '#38B2E6'
                  },
                  {
                    offset: 1,
                    color: '#0B3147'
                  }
                ]),
                opacity: 0.8
              }
            },
            data: this.yData
          }
        ]
      }
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.myChart) {
      this.myChart.dispose()
    }
  },
  methods: {
    initChart() {
      this.myChart = echarts.init(this.$refs.chart)
      this.myChart.setOption(this.chartOption)
    },
    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
    getColor(index) {
      const colors = ['#38B2E6', '#2DB1EF', '#2EA9E5']
      return colors[index] || colors[0]
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  text-align: center;
  
  h1 {
    font-size: 32px;
    margin-bottom: 10px;
    background: linear-gradient(90deg, #34DCFF, #2DB1EF);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
}

.chart-container {
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: center;
}

.chart-wrapper {
  width: 100%;
  // max-width: 900px;
  height: 100%;
  background: rgba(8, 25, 50, 0.5);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 20, 80, 0.4);
  padding: 20px;
  border: 1px solid rgba(100, 150, 255, 0.2);
}

.data-info {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.data-item {
  background: rgba(20, 40, 80, 0.5);
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 16px;
  display: flex;
  align-items: center;
  border: 1px solid rgba(100, 150, 255, 0.2);
}

.color-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
}

@media (max-width: 768px) {
  .chart-wrapper {
    height: 400px;
    padding: 15px;
  }
  
  .header h1 {
    font-size: 26px;
  }
  
  .data-item {
    font-size: 14px;
    padding: 10px 15px;
  }
}
</style>